import { Box, Divider, Typography } from '@mui/material';
import { t } from 'i18next';
import { useEffect } from 'react';
import { MuiStack } from '../../../components';
import { useAppSelector } from '../../../store/hooks';
import { DocFileIconSVG, ImageFileIconSVG, PDFFileIconSVG } from '../../spareParts/purchaseRequistion/assets/customIcons';
import { getOtherDetailsAPIGet } from '../apiCall';
import { StockTransferRequisitionAPIKeys } from '../entity';
var AttachmentComponent = function (props) {
    var _crud$StockTransferRe;
    var rowData = props.rowData;
    var crud = useAppSelector(function (state) { return state.crud; });
    var attachmentData = (_crud$StockTransferRe = crud[StockTransferRequisitionAPIKeys.attachmentList]) === null || _crud$StockTransferRe === void 0 || (_crud$StockTransferRe = _crud$StockTransferRe.data) === null || _crud$StockTransferRe === void 0 ? void 0 : _crud$StockTransferRe.ImageAttachments;
    useEffect(function () {
        getOtherDetails();
    }, []);
    var getOtherDetails = function () {
        var _rowData$row$id, _rowData$row;
        var request = {
            id: (_rowData$row$id = rowData === null || rowData === void 0 || (_rowData$row = rowData.row) === null || _rowData$row === void 0 ? void 0 : _rowData$row.id) !== null && _rowData$row$id !== void 0 ? _rowData$row$id : ''
        };
        getOtherDetailsAPIGet({
            request: request
        });
    };
    var renderIcon = function (contentType) {
        var type = contentType === null || contentType === void 0 ? void 0 : contentType.split('.')[1];
        switch (type) {
            case 'png':
            case 'jpg':
            case 'jpeg':
                return /*#__PURE__*/ React.createElement(ImageFileIconSVG, {
                    id: "moreDetail-img-icon",
                    sx: {
                        width: 40,
                        height: 40
                    }
                });
            case 'pdf':
                return /*#__PURE__*/ React.createElement(PDFFileIconSVG, {
                    id: "moreDetail-pdf-icon",
                    sx: {
                        width: 40,
                        height: 40
                    }
                });
            case 'Doc':
            case 'Docx':
                return /*#__PURE__*/ React.createElement(DocFileIconSVG, {
                    id: "moreDetail-doc-icon",
                    sx: {
                        width: 40,
                        height: 40
                    }
                });
            default:
                return null;
        }
    };
    return /*#__PURE__*/ React.createElement(React.Fragment, null, (attachmentData === null || attachmentData === void 0 ? void 0 : attachmentData.length) > 0 ? attachmentData === null || attachmentData === void 0 ? void 0 : attachmentData.map(function (file, index) { /*#__PURE__*/ return React.createElement("div", {
        key: index,
        id: "moreDetail-attachment-div"
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        id: "moreDetail-attachment-stack",
        border: '1px solid #DEE4EB',
        width: '100%',
        borderRadius: '12px',
        direction: 'column'
    }, /*#__PURE__*/ React.createElement(Box, {
        id: "moreDetail-attachment-box",
        padding: '16px',
        width: '100%'
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        id: "moreDetail-attachment-icon-stack",
        width: '100%',
        gap: '12px',
        alignItems: 'center'
    }, renderIcon(file.FileName), /*#__PURE__*/ React.createElement(MuiStack, {
        id: "moreDetail-attachment-text",
        justifyContent: 'space-between',
        width: '100%'
    }, /*#__PURE__*/ React.createElement(Typography, {
        id: "moreDetail-attachment-name",
        color: '#1B1D21',
        fontSize: '14px',
        fontWeight: '400'
    }, file.FileName), /*#__PURE__*/ React.createElement(Typography, {
        id: "moreDetail-attachment-size",
        fontSize: '14px',
        color: '#8593A3'
    }, file.size))))), index < attachmentData.length - 1 && /*#__PURE__*/ React.createElement(Divider, {
        style: {
            width: '100%'
        }
    })); }) : /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(MuiStack, {
        id: "moreDetail-no-attachment-stack"
    }, /*#__PURE__*/ React.createElement(Typography, {
        id: "moreDetail-no-attachment-text"
    }, t('No Attachment Found')))));
};
export default AttachmentComponent;
